<mat-card class="accion-emergencia-dialog selector-mapa-emergencia">
  <app-card-header
    title="Elegir ambulancia"
    subtitle="Tocá una ambulancia en el mapa o en la lista"
    icono="airport_shuttle"
    [botonCerrar]="true"
    (cerrar)="cerrar()"
  ></app-card-header>

  <div class="selector-mapa-cuerpo card-content-crear">
    <div class="selector-mapa-mapa">
      @if (mapCardConfig) {
        <app-map-card
          [config]="mapCardConfig"
          style="height: 100%; width: 100%"
          (entityClick)="onMarkerClick($event)"
        ></app-map-card>
      }
    </div>

    <div class="selector-mapa-lista">
      <div class="selector-mapa-grupo">
        Disponibles
        <span class="selector-mapa-cuenta">{{ disponibles.length }}</span>
      </div>
      @for (movil of disponibles; track movil._id) {
        <button
          type="button"
          class="selector-mapa-item irx-sin-estilo"
          [attr.aria-pressed]="movil._id === movilSeleccionado?._id"
          (click)="seleccionar(movil)"
        >
          <span
            class="punto"
            [style.background]="movil.colorComunicacion"
          ></span>
          <span class="selector-mapa-texto">
            <span class="selector-mapa-nombre">{{ movil.identificacion }}</span>
            <span class="movil-detalle">{{ movil.textoComunicacion }}</span>
          </span>
          @if (movil.distancia !== undefined) {
            <span class="selector-mapa-dist">
              {{ distanciaFormateada(movil.distancia) }}
            </span>
          }
        </button>
      } @empty {
        <span class="no-info">Sin ambulancias disponibles</span>
      }

      @if (ocupados.length) {
        <div class="selector-mapa-grupo">
          En otra emergencia
          <span class="selector-mapa-cuenta">{{ ocupados.length }}</span>
        </div>
        @for (movil of ocupados; track movil._id) {
          <button
            type="button"
            class="selector-mapa-item irx-sin-estilo ocupado"
            (click)="seleccionar(movil)"
          >
            <span
              class="punto"
              [style.background]="movil.colorComunicacion"
            ></span>
            <span class="selector-mapa-texto">
              <span class="selector-mapa-nombre">
                {{ movil.identificacion }}
              </span>
              <span class="movil-detalle">
                Emergencia {{ movil.asignadaA }}
              </span>
            </span>
            @if (movil.distancia !== undefined) {
              <span class="selector-mapa-dist">
                {{ distanciaFormateada(movil.distancia) }}
              </span>
            }
          </button>
        }
      }

      @if (sinPosicion) {
        <span class="movil-detalle selector-mapa-nota">
          {{ sinPosicion }} sin posición: no aparecen en el mapa.
        </span>
      }
    </div>
  </div>

  <mat-card-actions class="actions-create">
    <app-button
      matType="mat-fab extended"
      color="neutral"
      text="Cancelar"
      icon="close"
      (click)="cerrar()"
    ></app-button>
    <app-button
      matType="mat-fab extended"
      color="primary"
      text="Elegir"
      icon="check_circle"
      [disabled]="!movilSeleccionado"
      (click)="confirmar()"
    ></app-button>
  </mat-card-actions>
</mat-card>
